<template>
  <v-container fluid v-if="model">
      <v-row>
          <v-col cols=12>
              <v-card :loading="loading" :disabled="loading">
                <v-toolbar flat>
                    <v-icon left color="accent">mdi-package-variant-closed</v-icon>
                    <v-toolbar-title>Purchase order - Detail</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <PoChange :poId="model.id" />
                    <v-btn outlined @click="deleteItem" class="mr-2" v-if="['draft','cancelled'].includes(model.poStatus)" color="red">Delete</v-btn>
                    <v-btn outlined  @click="cancelItem" class="mr-2" v-if="!['draft','cancelled', 'received', 'partialyReceived'].includes(model.poStatus)" color="red">Cancel</v-btn>
                    <v-btn outlined  @click="cancelRemainingItem" class="mr-2" v-if="['partialyReceived'].includes(model.poStatus)" color="red">Cancel Remaining Items</v-btn>
                    <v-btn outlined  :to="'/purchase-order/update/'+model.id" class="mr-2" v-if="['draft','validated'].includes(model.poStatus)">Modify</v-btn>
                    <PurchaseOrderValidate
                      v-if="model.poStatus=='draft'"
                      :po="model"
                      @validated="getPO"
                    />
                </v-toolbar>
                <v-card-text class="text--primary">
                  <v-container fluid>
                      <v-row>
                        <v-col cols=9>
                          <v-row>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">PO Number</div>
                              {{model.poNumber}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Supplier</div>
                              {{model.supplier.name}}
                              <EditSupplier :supplier="model.supplier" />
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Currency</div>
                              <template v-if="model.currency">
                                {{model.currency}}
                              </template>
                              <EditCurrency v-else :po="model" @change="() => {this.getPO()}"/>
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Ship to Warehouse</div>
                              {{model.warehouse.name}}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Order Date</div>
                              {{model.orderDate}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Requested Ship Date</div>
                              {{model.requestedShipDate}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Order Cancel Date</div>
                              {{model.orderCancelDate}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Arrival Due Date</div>
                              {{model.arrivalDueDate}}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Sent Status</div>
                              {{model.sentStatus}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Tracking Info</div>
                              {{model.trackingInfo}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">Payment Status</div>
                              {{model.paymentStatus}}
                            </v-col>
                            <v-col cols=3>
                              <div class="text-capitalize overline text--secondary">PO Status</div>
                              {{model.poStatus}}
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols=3>
                          <Payment v-model="model" />
                        </v-col>
                      </v-row>
                    </v-container>
                </v-card-text>
              </v-card>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols=12>
              <v-card>
                <v-toolbar flat>
                    <v-icon color="accent" left>mdi-format-list-bulleted</v-icon>
                    <v-toolbar-title>PO's Rows</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <PoReceiveLines
                    :po="model"
                    :currency="model.currency"
                    :items="model.lines"
                    :canReceive="canReceive"
                    @received="getPO"
                  />
                </v-card-text>
              </v-card>
              <ConfirmBox ref="confirm" />
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import Payment from '../../components/purchaseOrder/Payment.vue';
import PurchaseOrderValidate from '../../components/purchaseOrder/Validate.vue';
import EditSupplier from '@components/supplier/Edit'
import ConfirmBox from '@components/ui/ConfirmBox.vue';
import PoChange from "../../components/purchaseOrder/PoChange.vue";
import PoReceiveLines from "../../components/purchaseOrder/PoReceiveLines.vue";
import EditCurrency from "../../components/purchaseOrder/EditCurrency.vue";

export default {
  components: { Payment, PurchaseOrderValidate, EditSupplier, ConfirmBox, PoChange, PoReceiveLines, EditCurrency },

  data: function() {
    return {
      currency:null,
      poId: null,
      model: null,
      loading:false,
    };
  },
  computed:{
    ...mapGetters("currencies",["currencies"]),
    ...mapGetters("purchaseOrders",{poErrors:'errors'}),
    headers(){

      let headers = [
          {text:'Sku', value:'product.sku'},
          {text:'Name', value:'product.name'},
          {text:'Unit Cost', value:'cost', align:'right'},
          {text:'Quantity', value:'quantity', align:'right'},
          {text:'Received', value:'received', align:'right'},
          {text:'Total', value:'total', align:'right'},
          {text:'Received', value:'total', align:'right'},
      ]

      if(this.canReceive){
        headers.push({text:'Actions', value:'actions'})
      }

      return headers
    },
    canReceive(){
      return this.model.poStatus=='validated' || this.model.poStatus == 'partialyReceived'
    },
    totalQuantity(){
      return this.model.lines.reduce((total,line)=>{
        return total + line.quantity;
      },0);
    },
    totalReceived(){
      return this.model.lines.reduce((total,line)=>{
        return total + line.received;
      },0);
    },
    totalAmount(){
      return this.model.lines.reduce((total,line)=>{
        return total + line.quantity*line.cost;
      },0);
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.poId = this.$route.params.id;
      this.getPO();
    } else {
      this.$route.push("/purchase-order");
    }
  },
  methods: {
    ...mapActions("purchaseOrders",{
      getPurchaseOrder:"get",
      setCurrency:'setCurrency',
      validatePurchaseOrder:'validate',
      deletePo:'delete',
      cancelPurchaseOrder:'cancel'
    }),
    getPO() {
      this.loading=true;
      this.getPurchaseOrder({
          id: this.poId
        })
        .then(data => (this.model = data.po))
        .finally(() => (this.loading = false));
    },
    saveCurrency(){
      this.setCurrency({poId:this.poId,currency:this.currency})
        .then(() => {
          this.getPO(this.poId)
        })
    },
    deleteItem(){
      confirm("Are you sure you want to delete this Purchase Orders?") &&
      this.deletePo(this.poId).then(()=>{
        this.$router.push("/purchase-order/list");
        this.flashMessage.success({
          message: "Delete PO Successfully",
        });
      }).catch(({data})=>{
        this.flashMessage.error({
          message: data.message
        });
      })
    },
    cancelItem(){
      confirm("Are you sure you want to cancel this Purchase Order?") &&
      this.cancelPurchaseOrder(this.poId)
      .then(() => {
        this.flashMessage.success({
          message: "PO Successfully Canceled"
        });
        this.getPO(this.poId)
      }).catch(({data})=>{
        this.flashMessage.error({
          message: data.message
        });
      })
    },
    async cancelRemainingItem() {
      if(await this.$refs.confirm.open("Cancel remaining items ?", "If you cancel this PO, the products remaining to be received will be canceled and those already received will remain.<br>Are you sure ?")){
        this.cancelPurchaseOrder(this.poId)
        .then(() => {
          this.flashMessage.success({
            message: "PO Successfully Canceled"
          });
          this.getPO(this.poId)
        }).catch(({data})=>{
          this.flashMessage.error({
            message: data.message
          });
        })
      }
      
    }
  }
}
</script>

<style>

</style>